import { useT } from '../i18n/I18nProvider';
import { LANG_LABEL, LANGS } from '../i18n/dictionary';
import { Icon } from './icons';

/**
 * Horní lišta. Přepínač jazyka je ZÁMĚRNĚ přímo v liště, ne v menu:
 * skladník, který neumí česky, nesmí volbu jazyka hledat v česky popsaném menu.
 * Kvůli místu je „Odhlásit se“ ikona s aria-label (řeší i bod 6 kritiky).
 */
interface Props {
  onLogout: () => void;
  /** Vstup do přehledu tras. Nepředá se = uživatel na něj nemá roli. */
  onRoutes?: () => void;
}

export function AppBar({ onLogout, onRoutes }: Props) {
  const { t, lang, setLang } = useT();

  return (
    <header className="appbar">
      <span className="brand">{t('app')}</span>

      {onRoutes && (
        <button
          className="logout"
          type="button"
          aria-label={t('routesEntry')}
          title={t('routesEntry')}
          onClick={onRoutes}
        >
          <Icon name="truck" />
        </button>
      )}

      <span className="langs" role="group" aria-label="Jazyk / Language">
        {LANGS.map((l) => (
          <button key={l} type="button" aria-pressed={l === lang} onClick={() => setLang(l)}>
            {LANG_LABEL[l]}
          </button>
        ))}
      </span>

      <button className="logout" type="button" aria-label={t('logoutA')} title={t('logoutA')} onClick={onLogout}>
        <Icon name="exit" />
      </button>
    </header>
  );
}
